import { render, staticRenderFns } from "./Login-trunk.vue?vue&type=template&id=019ba4b9&"
import script from "./Login-trunk.vue?vue&type=script&lang=js&"
export * from "./Login-trunk.vue?vue&type=script&lang=js&"
import style0 from "./Login-trunk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports